export { default as RelatedPostCard } from "./RelatedPostCard";
export type { RelatedPostCardProps } from "./RelatedPostCard"; 